module.exports = __webpack_public_path__ + "static/media/comment-svgrepo-com (3).372ab860.svg";